import { render, staticRenderFns } from "./SupportPayment.vue?vue&type=template&id=751c62fa&scoped=true"
import script from "./SupportPayment.vue?vue&type=script&lang=js"
export * from "./SupportPayment.vue?vue&type=script&lang=js"
import style0 from "./SupportPayment.vue?vue&type=style&index=0&id=751c62fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c62fa",
  null
  
)

export default component.exports